import script from "./govuknotifysmsConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./govuknotifysmsConfig.vue?vue&type=script&lang=ts&setup=true"

import "./govuknotifysmsConfig.vue?vue&type=style&index=0&id=1b209938&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b209938"]])

export default __exports__